(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timers = new Map();
  function setup(root = document) {
    root.querySelectorAll('[data-me-event-time]').forEach(time => {
      const date = new Date(time.dateTime);
      const timeZone = time.dataset.timeZone;
      if (!timeZone || !Number.isFinite(date.getTime())) return;
      try {
        const options = time.dataset.format === 'short'
          ? { day: 'numeric', month: 'short', year: 'numeric', timeZone }
          : time.dataset.format === 'calendar'
            ? { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone }
            : { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short', timeZone };
        time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', options).format(date);
      } catch { /* Keep the server-rendered date with its explicit offset. */ }
    });
    root.querySelectorAll('[data-me-event-track]').forEach(track => {
      if (track.dataset.ready) return;
      track.dataset.ready = 'true';
      const section = track.closest('.me-events');
      const buttons = section.querySelectorAll('[data-me-scroll]');
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        buttons.forEach(button => button.disabled = Number(button.dataset.meScroll) < 0 ? track.scrollLeft < 4 : track.scrollLeft >= maximum - 4);
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('.me-event-card');
        const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
        track.scrollBy({left: distance * Number(button.dataset.meScroll), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-me-city]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        if (!select.value) return;
        const url = new URL(select.value, window.location.origin);
        if (url.protocol === 'https:' || url.protocol === 'http:') window.location.assign(url.href);
      });
    });
    root.querySelectorAll('[data-me-countdown]').forEach(bar => {
      if (timers.has(bar)) return;
      const input = bar.dataset.meCountdown;
      const target = Date.parse(input);
      if (!input || !Number.isFinite(target) || !/(Z|[+-]\d{2}:\d{2})$/.test(input)) {
        bar.hidden = true;
        return;
      }
      const update = () => {
        if (!bar.isConnected) { clearInterval(timers.get(bar)); timers.delete(bar); return; }
        const remaining = Math.max(0, Math.floor((target - Date.now()) / 1000));
        if (remaining === 0) {
          bar.querySelectorAll('.me-countdown').forEach(counter => {counter.hidden = true;});
          bar.querySelector('.me-countdown__ended').hidden = false;
          const action = bar.querySelector('[data-me-countdown-action]');
          if (action && bar.dataset.eventUrl) action.href = bar.dataset.eventUrl;
          if (bar.dataset.eventInfoLabel) {
            bar.querySelectorAll('[data-me-countdown-label], .me-countdown-bar__title > strong').forEach(label => { label.textContent = bar.dataset.eventInfoLabel; });
          }
          clearInterval(timers.get(bar));
          return;
        }
        const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60};
        Object.entries(values).forEach(([key, value]) => {bar.querySelectorAll(`[data-${key}]`).forEach(counter => {counter.textContent = String(value).padStart(2, '0');});});
      };
      timers.set(bar, setInterval(update, 1000));
      update();
    });
    root.querySelectorAll('.me-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
      menu.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => {menu.open = false;}));
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.me-mobile-menu[open]').forEach(menu => {if (!menu.contains(event.target)) menu.open = false;});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-me-countdown]').forEach(bar => {clearInterval(timers.get(bar));timers.delete(bar);});
  });
})();
